import { createHeadlessEditor } from '@lexical/headless';
import { createYjsBinding, syncYjsChangesToLexical } from '@lexical/yjs';
import { applyUpdate, Doc } from 'yjs';
import { BlockEditorNodes } from '../../Lexical/Nodes/AllNodes';
import { handleEditorChange } from '../../Utils';
import { CollaborationDocumentId } from './CollaborationConfig';
import { LocalCollaborationProvider } from './LocalCollaborationProvider';
/** Renders a Yjs state of a Super note to the Lexical JSON stored in the note text, without a mounted editor */
export function renderCollaborationState(state, previewLength) {
    const editor = createHeadlessEditor({
        namespace: 'BlocksEditor',
        nodes: BlockEditorNodes,
        onError: (error) => {
            throw error;
        },
    });
    const doc = new Doc();
    const binding = createYjsBinding({
        editor,
        id: CollaborationDocumentId,
        doc,
        docMap: new Map([[CollaborationDocumentId, doc]]),
    });
    const provider = new LocalCollaborationProvider(doc, undefined);
    const root = binding.root.getSharedType();
    const observer = (events) => syncYjsChangesToLexical(binding, provider, events, false, () => undefined);
    root.observeDeep(observer);
    applyUpdate(doc, state);
    root.unobserveDeep(observer);
    /** Commits the update queued by syncYjsChangesToLexical */
    editor.update(() => undefined, { discrete: true });
    let result = { text: '', previewPlain: '' };
    const editorState = editor.getEditorState();
    editorState.read(() => {
        handleEditorChange(editorState, previewLength, (text, previewPlain) => {
            result = { text, previewPlain };
        });
    });
    binding.root.destroy(binding);
    doc.destroy();
    return result;
}
